import React, { useCallback, useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import "./AppCarousel.css";
import { FcNext, FcPrevious } from "react-icons/fc";

export default function AppCarousel({
  data = [],
  renderItem,
  options = {},
  autoplay = true,
  onSlideChange,
}) {
  const autoplayPlugin = autoplay
    ? Autoplay({ delay: 15000, stopOnInteraction: false })
    : null;

  const [emblaRef, emblaApi] = useEmblaCarousel(
    options,
    autoplay ? [autoplayPlugin] : []
  );
  const [selectedIndex, setSelectedIndex] = useState(0);

  const scrollPrev = useCallback(
    () => emblaApi && emblaApi.scrollPrev(),
    [emblaApi]
  );
  const scrollNext = useCallback(
    () => emblaApi && emblaApi.scrollNext(),
    [emblaApi]
  );
  const scrollTo = useCallback(
    (i) => emblaApi && emblaApi.scrollTo(i),
    [emblaApi]
  );

  useEffect(() => {
    if (!emblaApi) return;

    const onSelect = () => {
      const snapIndex = emblaApi.selectedScrollSnap();
      setSelectedIndex(snapIndex);

      const item = data[snapIndex];
      if (item && onSlideChange) {
        onSlideChange(item, snapIndex);
      }
    };

    emblaApi.on("select", onSelect);
    onSelect();

    return () => {
      emblaApi.off("select", onSelect);
    };
  }, [emblaApi, data, onSlideChange]);

  return (
    <div className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {data.map((item, index) => (
            <div className="embla__slide" key={item?.slide?.slideId}>
              {renderItem(item, index)}
            </div>
          ))}
        </div>
      </div>

      {data?.length > 1 && (
        <>
          <button
            className="embla__button embla__button--prev"
            onClick={scrollPrev}
          >
            <FcPrevious />
          </button>
          <button
            className="embla__button embla__button--next"
            onClick={scrollNext}
          >
            <FcNext />
          </button>
        </>
      )}

      <div className="embla__dots">
        {data.map((_, index) => (
          <button
            key={index}
            className={`embla__dot ${index === selectedIndex ? "is-selected" : ""}`}
            onClick={() => scrollTo(index)}
          />
        ))}
      </div>
    </div>
  );
}
